import {
  HOME,
  LANDLORDS,
  MPPI,
  RENT_PROTECTION,
  TENANTS_CONTENTS,
  TENANTS_LIABILITY,
} from "./questionset.constants";

export const INSURER_TYPE = [
  {
    name: "Axa",
    image: "axa",
    onPanelUntil: {
      [LANDLORDS]: "2026-03-31",
      [HOME]: null,
    },
    productGroups: [HOME, LANDLORDS],
  },
  {
    name: "Highway Insurance Company Limited",
    displayName: "Allianz",
    image: "allianz",
    onPanelUntil: null,
    productGroups: [HOME, LANDLORDS, TENANTS_CONTENTS],
  },
  {
    name: "RSA",
    image: "rsa",
    onPanelUntil: "2024-12-31",
    productGroups: [HOME, LANDLORDS, TENANTS_CONTENTS],
  },
  {
    name: "Integra",
    image: "integra",
    onPanelUntil: null,
    productGroups: [HOME],
  },
  {
    name: "Bspoke",
    image: "bspoke",
    onPanelUntil: "2025-04-30",
    productGroups: [TENANTS_CONTENTS],
  },
  {
    name: "UKG",
    image: "ukg",
    onPanelUntil: "2024-09-01",
    productGroups: [LANDLORDS, TENANTS_CONTENTS],
  },
  {
    name: "Property Guard",
    image: "property-guard",
    onPanelUntil: null,
    productGroups: [TENANTS_LIABILITY],
  },
  {
    name: "Covea Insurance plc",
    image: "covea",
    onPanelUntil: null,
    productGroups: [MPPI],
  },
  {
    name: "Phoenix MGA",
    displayName: "Ageas",
    image: "ageas",
    onPanelUntil: null,
    productGroups: [HOME],
  },
  {
    name: "Tradex",
    image: "tradex",
    onPanelUntil: null,
    productGroups: [HOME, TENANTS_CONTENTS],
  },
  {
    name: "Arc",
    image: "arc",
    onPanelUntil: null,
    productGroups: [RENT_PROTECTION],
  },
  {
    name: "AmTrust",
    image: "amtrust",
    onPanelUntil: null,
    productGroups: [TENANTS_CONTENTS],
  },
  {
    name: "AmTrust Specialty Limited",
    image: "amtrust",
    onPanelUntil: null,
    productGroups: [MPPI],
  },
  {
    name: "Arkel",
    image: "arkel",
    onPanelUntil: null,
    productGroups: [LANDLORDS],
  },
];

export const UNKNOWN_INSURER_NAME = "Unknown";
export const UNKNOWN_INSURER = {
  name: UNKNOWN_INSURER_NAME,
  image: "unknown",
};
